import { CerFormAdapter } from "@cer/cer-form/cer-form-adapter";
import { CerFormView } from "@cer/cer-form/cer-form-view";

export class ProductTypeForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'udgivelse-typer', dataApiName: 'ProductType', text: 'Typer, udgivelser',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      },
      fieldMetadata: [
        { name: 'isPrimary', text: 'Tryk', format: 'CheckBox' },
        { name: 'isAudio', text: 'Audio', format: 'CheckBox' },
        { name: 'isDigital', text: 'Digital', format: 'CheckBox' },
        { name: 'distributor', fieldType: 'productDistributor' },
        { name: 'legacyId', text: 'Opr. Id', tooltipText: 'Id fra oprindelig database', visible: false, format: 'Integer' }
      ]
    });

  }
}
